// extracted by mini-css-extract-plugin
module.exports = {"landingItems":"PdpRespSimilarItemsLanding__landingItems__1a7fb355","landingItem":"PdpRespSimilarItemsLanding__landingItem__1a7fb355"};